{
  "app-switcher-discovery-section.discover-more-products": "探索更多應用程式",
  "app-switcher-discovery-section.more-atlassian-products": "更多 Atlassian 應用程式",
  "app-switcher-discovery-section.recommended-for-your-team": "推薦給您的團隊",
  "confluence.continue.reading.body": "<text>{pageOwnerName} 的相關閱讀內容</text>",
  "confluence.continue.reading.read-now": "立即閱讀",
  "continue-reading.ai-footer.content-quality": "<text>內容品質可能會有所不同</text>",
  "continue-reading.ai-footer.powered-by-ai": "<text>由人工智慧提供技術支援</text>",
  "first-party-recommendation.reason-1": "您團隊的規模",
  "first-party-recommendation.reason-2": "您現有的 Atlassian 產品",
  "growth.admin-hub-recommendation.actions-heading": "動作",
  "growth.admin-hub-recommendation.free-plan": "免費，可隨時取消",
  "growth.admin-hub-recommendation.heading": "根據您現有產品的推薦",
  "growth.admin-hub-recommendation.plan-heading": "計畫",
  "growth.admin-hub-recommendation.try-it-now": "立刻試用",
  "growth.app-switcher-discovery-section.flag.description": "此內容以後會較少出現在這裡。",
  "growth.app-switcher-discovery-section.flag.title": "知道了，謝謝您告訴我們",
  "growth.app-switcher-discovery-section.wac-toast.close.aria-label": "關閉快顯訊息",
  "growth.confluenceNudgeFlag.flagHeadline.commentedOnPage.text": "<h>{name} 已在您的頁面上留言</h>",
  "growth.confluenceNudgeFlag.flagHeadline.mentionedInComment.text": "<h>{name} 已在留言中提及您</h>",
  "growth.confluenceNudgeFlag.flagHeadline.mentionedInPage.text": "<h>{name} 已在頁面上提及您</h>",
  "growth.confluenceNudgeFlag.repliedSuccessFlagTitle.text": "回覆已傳送至 {mentionerName}",
  "growth.confluenceNudgeFlag.reply-cancel-button": "取消",
  "growth.confluenceNudgeFlag.reply-confirm-button": "回覆",
  "growth.confluenceNudgeFlag.reply-on-page-confirm-button.text": "<a>在頁面上回覆</a>",
  "growth.confluenceNudgeFlag.replyFieldGenericError": "無法傳送留言。請稍後再試一次。",
  "growth.confluenceNudgeFlag.see-page-confirm-button": "<a>參閱頁面</a>",
  "growth.confluenceNudgeFlag.see-page-confirm-button.success.flag": "<a>參閱頁面</a>",
  "growth.confluenceNudgeFlag.viewReactionsError": "無法載入回應",
  "growth.recommendation-atlas.value-proposition": "貴公司的團隊合作目錄",
  "growth.recommendation-confluence.cta.label": "試用 Confluence",
  "growth.recommendation-confluence.jira-your-work.description": "建立集中的空間來整理要求、版本資訊、目標等。",
  "growth.recommendation-confluence.jira-your-work.header": "讓所有人掌握一致資訊",
  "growth.recommendation-confluence.jira-your-work.header-image-alt-text": "多位使用者在同一時間於相同頁面上協作和留言",
  "growth.recommendation-confluence.jira-your-work.reasons-modal.message": "我們認為 {confluence} 將提高您團隊的生產力。這項建議的依據是：",
  "growth.recommendation-confluence.product-alt-text": "標題為季度規劃的文件。該文件包含任務、範圍和每月計畫等詳細資料。",
  "growth.recommendation-confluence.product-heading": "為所有人建立單一事實來源",
  "growth.recommendation-confluence.product-name.header": "在頁面上即時協作",
  "growth.recommendation-confluence.product-subheading": "從單一位置建立並連結文件，例如版本資訊、產品要求和藍圖。",
  "growth.recommendation-confluence.reasons-modal.message": "我們認為 {confluence} 能提高您團隊的生產力。這項建議的依據是：",
  "growth.recommendation-confluence.value-proposition": "文件協作",
  "growth.recommendation-jira.product-alt-text": "可將任務從「待處理」移到「進行中」和「完成」的看板檢視方式",
  "growth.recommendation-jira.product-heading": "規劃和追蹤跨團隊的工作",
  "growth.recommendation-jira.product-subheading": "將宏大的構想細分成可行的步驟。組織工作、建立里程碑、對應相依性，並清楚掌握所有團隊的狀況。",
  "growth.recommendation-jpd-product-roadmap.value-proposition": "透過自訂藍圖，讓每個人目標一致",
  "growth.recommendation-jpd.admin-hub-recommendation-value-proposition": "在相同平台上規劃和交付所有內容",
  "growth.recommendation-jpd.cta.label": "試用 Jira Product Discovery",
  "growth.recommendation-jpd.jira-your-work.description": "設定構想的優先順序，然後輕鬆移動到交付，過程中不會丟失任何詳細資料。",
  "growth.recommendation-jpd.jira-your-work.header": "以合適的方式建置正確的功能",
  "growth.recommendation-jpd.jira-your-work.header-image-alt-text": "Jira Product Discovery 中的構想自動轉換為 Jira 中的「大型工作」",
  "growth.recommendation-jpd.jira-your-work.reasons-modal.message": "我們認為 {jpd} 將提高您團隊的生產力。這項建議的依據是：",
  "growth.recommendation-jpd.product-alt-text": "五個構想全部整理至「現在」、「下一個」和「後續」的群組，每個構想都有一個連結的目標、分數和投入排名。",
  "growth.recommendation-jpd.product-heading": "以正確的方式建置正確的功能",
  "growth.recommendation-jpd.product-name.header": "將深入解析轉化為行動計畫",
  "growth.recommendation-jpd.product-subheading": "擷取您的構想並排定優先順序，然後輕鬆將其轉移到交付中，過程中不會丟失任何詳細資料。",
  "growth.recommendation-jpd.reasons-modal.message": "我們認為 {jpd} 能提高您團隊的生產力。這項建議的依據是：",
  "growth.recommendation-jpd.value-proposition": "排定優先順序、協作並提供新構想",
  "growth.recommendation-jsm-work-request.value-proposition": "建立一個地方來管理要求",
  "growth.recommendation-jsm.admin-hub-recommendation-value-prop": "將您的開發人員、IT 和營運整合至相同平台。",
  "growth.recommendation-jsm.cta.label": "試用 Jira Service Management",
  "growth.recommendation-jsm.jira-your-work.description": "將支援團隊與開發團隊聯繫起來，以了解從要求到解決的全部過程。",
  "growth.recommendation-jsm.jira-your-work.header": "連結您的團隊，清楚呈現工作",
  "growth.recommendation-jsm.jira-your-work.header-image-alt-text": "來自 Slack、Teams 和電子郵件的要求自動轉換為 Jira Service Management 要求",
  "growth.recommendation-jsm.jira-your-work.reasons-modal.message": "我們認為 {jsm} 將提高您團隊的生產力。這項建議的依據是：",
  "growth.recommendation-jsm.product-alt-text": "七個要求都整理在單一位置，每個要求都有連結的狀態和專案。",
  "growth.recommendation-jsm.product-heading": "讓您的工作更加明顯可見",
  "growth.recommendation-jsm.product-name.header": "自動化工作流程，更快解決問題",
  "growth.recommendation-jsm.product-subheading": "在單一平台上連接開發人員和營運團隊，以便進行協作，並且連結從要求到解決的整體概況。",
  "growth.recommendation-jsm.reasons-modal.message": "我們認為 {jsm} 能提高您團隊的生產力。這項建議的依據是：",
  "growth.recommendation-jsm.value-proposition": "協作 IT 服務管理",
  "growth.recommendation-jsw-dynamic-description.value-proposition": "規劃、追蹤和整理專案",
  "growth.recommendation-jsw-visualize-work.cta.label": "試用 Jira",
  "growth.recommendation-jsw-visualize-work.product-name.header": "將您的專案呈現在列表和看板等位置",
  "growth.recommendation-jsw-visualize-work.reasons-modal.message": "我們認為 {product} 能提高您團隊的生產力。這項建議的依據是：",
  "growth.recommendation-jsw.recommendations.dropdown-menu-trigger.aria-label": "{productName} 個選項",
  "growth.recommendation-jsw.value-proposition": "專案與議題追蹤",
  "growth.recommendation-jwm.value-proposition": "ITSM 讓高效團隊發揮無限潛能",
  "growth.recommendation-loom.cta.label": "試用 Loom",
  "growth.recommendation-loom.product-name-for-use-case": "畫面錄製工具",
  "growth.recommendation-loom.product-name.header": "輕鬆錄製和分享影片",
  "growth.recommendation-loom.reasons-modal.message": "我們認為 {product} 能提高您團隊的生產力。這項建議的依據是：",
  "growth.recommendation-loom.value-proposition": "輕鬆錄製和分享影片",
  "growth.recommendation-loom.value-proposition-for-use-case": "錄製並使用即時連結分享",
  "growth.recommendation-opsgenie.value-proposition": "新式事件管理",
  "growth.recommendation-product-store.learn-cta-button-text": "深入了解",
  "growth.recommendation-product-store.try-cta-button-text": "立刻試用",
  "growth.team-25-ipm.jira-your-work.call-to-action.watch-now.text": "立即觀看",
  "growth.team-25-ipm.jira-your-work.description": "了解 Rovo 如何透過人工智慧搜尋功能、聊天和客服人員，改善您的工作方式。",
  "growth.team-25-ipm.jira-your-work.header-image-alt-text": "請參閱 Rovo 公告！",
  "growth.team-25-ipm.jira-your-work.reasons-modal.message": "Atlassian 最近在 Team '25 上分享了多個公告，我們希望確保您了解新的功能。",
  "growth.team-25-ipm.jira-your-work.title": "透過 Rovo 達成事半功倍",
  "jpd.customRoadmapsPlacementHeader": "自訂藍圖",
  "jpd.customRoadmapsPlacementTagLine": "建立和分享整體計畫",
  "jpd.deliveryProgressPlacementHeader": "交付進度",
  "jpd.deliveryProgressPlacementTagLine": "將構想連結至交付狀態",
  "jpd.ideasAndPrioritiesPlacementHeader": "構想和優先順序",
  "jpd.ideasAndPrioritiesPlacementTagLine": "使用 RICE 和資料排定構想的優先順序",
  "jpd.insightsAndIdeasPlacementHeader": "深入解析與構想",
  "jpd.insightsAndIdeasPlacementTagLine": "在單一位置上查看構想和意見反應",
  "jsm.assetsPlacementHeader": "Assets",
  "jsm.assetsPlacementTagLine": "將企業資產整合在一起",
  "jsm.bugTrackingPlacementHeader": "錯誤追蹤",
  "jsm.bugTrackingPlacementTagLine": "在單一位置上收集並解決錯誤",
  "jsm.changeManagementPlacementHeader": "變更管理",
  "jsm.changeManagementPlacementTagLine": "建立用於管理變更的單一位置",
  "jsm.customerServicePlacementHeader": "客戶服務",
  "jsm.customerServicePlacementTagLine": "幫助使用者獲得服務和支援",
  "jsm.helpDeskPlacementHeader": "服務台",
  "jsm.helpDeskPlacementTagLine": "接收要求並提供支援",
  "jsm.issueManagementPlacementHeader": "議題管理",
  "jsm.issueManagementPlacementTagLine": "擷取並解決議題",
  "jsm.onCallSchedulesPlacementHeader": "待命排程",
  "jsm.onCallSchedulesPlacementTagLine": "建立排程、輪班等",
  "jsm.workRequestsPlacementHeader": "工作要求",
  "jsm.workRequestsPlacementTagLine": "建立用於管理要求的單一位置",
  "post-office.ad-controls.confluence-continue-reading-nudge.reason.activity-in-product": "您在 Confluence 中的活動",
  "post-office.ad-controls.confluence-continue-reading-nudge.reason.suggested-next-steps": "提供您建議的後續步驟，協助您充分運用 Atlassian 產品或服務",
  "post-office.ad-controls.confluence-continue-reading-nudge.why-am-i-seeing-this.message": "您所看到的專屬推薦是以這些為根據：",
  "post-office.ad-controls.confluence-continue-reading-nudge.why-am-i-seeing-this.title": "為什麼我會看到此內容？",
  "post-office.ad-controls.confluence-mcu-nudge-flag-message.recommendation-basis": "您所看到的專屬推薦是以這些為根據：",
  "post-office.ad-controls.confluence-mcu-nudge-flag-reason.activity-in-product": "您在 Confluence 中的活動",
  "post-office.ad-controls.confluence-mcu-nudge-flag-title.why-am-i-seeing-this": "為什麼我會看到此內容？",
  "post-office.ad-controls.confluence-mcu-nudge-flag.suggestions": "提供您建議的後續步驟，協助您充分運用 Atlassian 產品或服務",
  "post-office.ad-controls.custom-reason.existing-products.no-translate": "the second reason for displaying the message to the customer",
  "post-office.ad-controls.custom-reason.team-size.no-translate": "the first reason for displaying the message to the customer",
  "post-office.ad-controls.default-reason.existing-products": "您現有的 Atlassian 產品",
  "post-office.ad-controls.default-reason.team-size": "您團隊的規模",
  "post-office.ad-controls.dismiss-flag.not-interested.subtitle": "此內容以後會較少出現在這裡。",
  "post-office.ad-controls.dismiss-flag.not-interested.title": "知道了，謝謝您告訴我們",
  "post-office.ad-controls.dropdown-item.not-interested.label": "不感興趣",
  "post-office.ad-controls.dropdown-item.why-am-i-seeing-this.label": "為什麼我會看到此內容？",
  "post-office.ad-controls.dropdown-menu-trigger.aria-label": "{messageInstanceId} 選項選單",
  "post-office.ad-controls.dropdown-menu-trigger.tooltip": "更多動作",
  "post-office.ad-controls.next-best-action-message.recommendation-basis": "這項建議的依據是：",
  "post-office.ad-controls.next-best-action-reason.actions-done-so-far": "您到目前為止在產品中所做的事",
  "post-office.ad-controls.next-best-action-reason.suggestions": "我們有哪些建議可協助您充分運用 Atlassian 產品或工具",
  "post-office.ad-controls.next-best-action-title.why-am-i-seeing-this": "為什麼我會看到此內容？",
  "post-office.ad-controls.reasons-modal.accept-button.label-ok": "確定",
  "post-office.ad-controls.reasons-modal.body": "我們認為這適合您，推論根據是：",
  "post-office.ad-controls.reasons-modal.privacy-policy-link.text": "進一步了解您所適用的 Atlassian 資料隱私權",
  "post-office.ad-controls.reasons-modal.title": "為什麼我會看到此內容？",
  "post-office.close-button.tooltip": "關閉",
  "post-office.confluence-banner-first-party-recommendation.try-it-now": "立即試用",
  "post-office.confluence-side-nav.next-best-action.craete-space-header": "集中顯示團隊的專案和文件。",
  "post-office.confluence-side-nav.next-best-action.create-page-cta-message": "建立頁面",
  "post-office.confluence-side-nav.next-best-action.create-page-header": "規劃專案、記筆記和追蹤任務。",
  "post-office.confluence-side-nav.next-best-action.create-space-cta-message": "建立空間",
  "post-office.confluence-side-nav.next-best-action.create-whiteboard-cta-message": "建立白板",
  "post-office.confluence-side-nav.next-best-action.create-whiteboard-header": "產生新構想並呈現您的工作。",
  "post-office.example-message-template.example-placement.cta-button.no-translate": "Try now",
  "post-office.example-placement-advanced.learn-more-modal.done-button-text.no-translate": "Done",
  "post-office.growth.jira-assigned-nudge.sample-hello-message.no-translate": "Hello, *This is notification test from post office*",
  "post-office.growth.recommendation-jpd.confluence-home-banner.description": "請確保您的團隊使用 Jira Product Discovery 建立合適內容。",
  "post-office.growth.recommendation-jpd.confluence-home-banner.header": "在單一位置擷取您的構想和客戶意見反應",
  "post-office.growth.recommendation-jpd.confluence-home-banner.logo-alt-text": "Jira Product Discovery 產品標誌",
  "post-office.growth.recommendation-jsm.confluence-home-banner.description": "自動將 Slack、Teams 和電子郵件要求轉換為工單。",
  "post-office.growth.recommendation-jsm.confluence-home-banner.header": "查看從提出到解決要求的完整過程",
  "post-office.growth.recommendation-jsm.confluence-home-banner.logo-alt-text": "Jira Service Management 產品標誌",
  "post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.description": "隨時針對團隊正在處理的工作，查看分析和深入解析",
  "post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.header": "將即時資料從 Jira 同步到 Confluence 中的任何文件",
  "post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.logo-alt-text": "Jira 產品標誌",
  "post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.description": "增加 Confluence 和 Jira 後，76% 的客戶提交專案的速度變快了。",
  "post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.header": "快速打造世界級產品",
  "post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.logo-alt-text": "Jira 產品標誌",
  "post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.description": "Jira 可讓您以適合您和團隊的方式，檢視專案和任務。",
  "post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.header": "將專案呈現在列表、看板、待辦事項等位置",
  "post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.logo-alt-text": "Jira 產品標誌",
  "post-office.jira-side-nav-first-party-recommendation.try-product": "試用產品",
  "post-office.jira-your-work-first-party-recommendation.learn-more": "深入了解",
  "post-office.jira-your-work-first-party-recommendation.learn-more.alt-text": "進一步探索 {product}",
  "post-office.jira-your-work-first-party-recommendation.try-it-now": "立即試用",
  "post-office.jira-your-work-first-party-recommendation.try-product": "試用產品",
  "post-office.nav-4-section.main-heading.no-translate": "Welcome to Placements v2",
  "post-office.test-placement.main-heading.no-translate": "Welcome to Placements v2",
  "post-office.test-placement.test-message.dismiss-button.no-translate": "Dismiss",
  "post-office.test-placement.test-message.learn-more-button.no-translate": "Learn more",
  "recommendation-controls.existing-products": "您現有的 Atlassian 產品",
  "recommendation-controls.team-size": "您團隊的規模",
  "recommendations.ad-controls.dismiss-flag.not-interested.subtitle": "此內容以後會較少出現在這裡。",
  "recommendations.ad-controls.dismiss-flag.not-interested.title": "知道了，謝謝您告訴我們",
  "recommendations.ad-controls.reasons-modal.accept-button.label": "確定",
  "recommendations.ad-controls.reasons-modal.accept-button.label-ok": "確定",
  "recommendations.ad-controls.reasons-modal.body": "我們認為 {productName} 將提高您團隊的生產力。這項建議的依據是：",
  "recommendations.ad-controls.reasons-modal.privacy-policy-link.text": "進一步了解您所適用的 Atlassian 資料隱私權",
  "recommendations.ad-controls.reasons-modal.title": "為什麼我會看到此內容？",
  "switcher.ad-controls.dropdown-item.not-interested.label": "不感興趣",
  "switcher.ad-controls.dropdown-item.why-am-i-seeing-this.label": "為什麼我會看到此內容？",
  "test": "default message"
}